import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Offene Bewertungen")
const _hoisted_2 = /*#__PURE__*/_createVNode("p", null, "Hier sehen Sie alle Bewertungen die Sie noch nicht abgeschlossen haben.", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "card-pre-header warning" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Zur Bewertung")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")
  const _component_ion_card_title = _resolveComponent("ion-card-title")
  const _component_ion_card_header = _resolveComponent("ion-card-header")
  const _component_ion_card_content = _resolveComponent("ion-card-content")
  const _component_ion_card = _resolveComponent("ion-card")
  const _component_IonCol = _resolveComponent("IonCol")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_IonRow = _resolveComponent("IonRow")
  const _component_IonGrid = _resolveComponent("IonGrid")
  const _component_IonContent = _resolveComponent("IonContent")
  const _component_IonPage = _resolveComponent("IonPage")

  return (_openBlock(), _createBlock(_component_IonPage, null, {
    default: _withCtx(() => [
      _createVNode(_component_Header, {
        title: _ctx.getJurorName,
        back: true
      }, null, 8, ["title"]),
      _createVNode(_component_IonContent, { fullscreen: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_IonGrid, null, {
            default: _withCtx(() => [
              _createVNode(_component_IonRow, { class: "ion-justify-content-center ion-align-items-center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_IonCol, {
                    class: "ion-text-center ion-margin-top ion-padding-top ",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_card, { color: "light" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card_header, { class: "ion-padding" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_card_title, null, {
                                default: _withCtx(() => [
                                  _hoisted_1
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_card_content, null, {
                            default: _withCtx(() => [
                              _hoisted_2
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getActiveResultPointList, (result) => {
                    return (_openBlock(), _createBlock(_component_IonCol, {
                      key: result.participantsId,
                      class: "ion-text-center",
                      "size-xs": "12",
                      "size-md": "6",
                      "size-xl": "4"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card, { color: "light" }, {
                          default: _withCtx(() => [
                            _hoisted_3,
                            _createVNode(_component_ion_card_header, null, {
                              default: _withCtx(() => [
                                _createVNode("h6", null, _toDisplayString(_ctx.getCheeseInfos(result.participantsId).coding), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_ion_card_content, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_button, {
                                  onClick: ($event: any) => (_ctx.openRating(_ctx.getCheeseInfos(result.participantsId))),
                                  expand: "block"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_4
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}